module.exports = __webpack_public_path__ + "static/media/pie_bg.129c867e.svg";